<template>
  <ModalContainer queryParam="view" ref="modalContainer">

    <b-card>
      <h4 class="text-center mb-2">Información del Auxiliar</h4>

      <div class="mb-1">
        <i class="fas fa-toggle-on mr-1"/>
        <span>Estado : {{ auxiliar.estado }}</span>
      </div>

      <div class="mb-1">
        <i class="fas fa-barcode mr-1"/>
        <span>Identificación: {{ auxiliar.identificacion }}</span>
      </div>

      <div class="mb-1">
        <i class="fas fa-tag mr-1"/>
        <span>Nombre: {{ auxiliar.nombre }}</span>
      </div>

      <div class="mb-1">
        <i class="fas fa-briefcase-medical mr-1"/>
        <span>Tipo de Especialidad : {{ auxiliar.tipoEspecialidad }}</span>
      </div>
    
      <div class="mb-1">
        <i class="fas fa-circle mr-1"/>
        <span>Feha de Inicio: {{ auxiliar.fechaInicio }}</span>
      </div>

      <div class="mb-1">
        <i class="fas fa-circle mr-1"/>
        <span>Fecha de Fin: {{ auxiliar.fechaFin }}</span>
      </div>

    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from '@/shared/components';
import { auxiliarMedicoService } from '../../services';
  
export default {

  name: 'VerAuxiliar',

  components: {
    ModalContainer
  },


  data() {
    return {
      auxiliar: {
        token: '',
        identificacion: '',
        nombre: '',
        tipoEspecialidad: '',
        fechainicio: '',
        fechafin: '',
        estado: 0,
      },
    };
  },

  created() {
    this.getData();
  },

  methods: {

    async getData() {

      const tokenAuxiliar = this.$route.query.view;
      const responseAuxiliar = await auxiliarMedicoService.getAll({ tokenAuxiliar });
      if(!responseAuxiliar) return;

      const dataAuxiliar = responseAuxiliar.auxiliares[0];  

      this.auxiliar = {
        nombre           : `${dataAuxiliar.idPersona.primerApellido} ${dataAuxiliar.idPersona.primerNombre}`,
        identificacion   : dataAuxiliar.idPersona.identificacion,
        tipoEspecialidad : dataAuxiliar.tipoauxiliar?.descripcion,
        estado           : dataAuxiliar.activo ? 'Activo' : 'Inactivo',
        fechaInicio      : dataAuxiliar.fechainicio,
        fechaFin         : dataAuxiliar.fechafin,
      }
        
    }
  },

  watch: {
    '$route.query.view': {
      handler() {
        this.getData();
      }
    }
  }
};
</script>